import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  InputType,
  ValidationRule,
} from "../services/types/ComponentTypes";

/** Screen 180 — aligned with DB screen config (bank_reconciliation_voucher). */
export const screen_180_bank_reconciliation_voucher: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    title: "Bank reconciliation voucher",
    style: {},
    childComponents: [
      {
        componentType: LayoutTypes.FORM,
        Name: "bank_reconciliation_voucher",
        TableName: "vouchers",
        Plugins: [
          {
            type: "api",
            module: "accounts",
          },
        ],
        DisplayName: "vouchers",
        columnNumber: "m1 t1 w1",
        style: {
          padding: 10,
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
        },
        Fields: [
          {
            componentType: LayoutTypes.FIELD_GROUP,
            Label: "Bank reconciliation voucher details",
            BindValue: "bank_reconciliation_voucher_details",
            style: {
              direction: FlexDirection.COLUMN,
            },
            childComponents: [
              {
                IncludeLabel: true,
                Label: "Reconciliation voucher no.",
                PlaceHolder: "Will be auto generated (BRK_...)",
                IsMandatory: false,
                BindValue: "txt_voucher_no",
                Json_Attribute: "voucher_no",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                AutoPopulate: true,
                IsReadOnly: true,
                AutoPopulate_format: "BRK_[******]",
                IsVerticalView: true,
                inputType: InputType.TEXT,
              },
              {
                IncludeLabel: true,
                Label: "Transaction voucher no.",
                PlaceHolder: "Receipt / payment / journal voucher no.",
                IsMandatory: false,
                BindValue: "txt_source_voucher_no",
                Json_Attribute: "source_voucher_no",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: true,
                IsReadOnly: true,
                IsVerticalView: true,
                inputType: InputType.TEXT,
              },
              {
                IncludeLabel: true,
                Label: "Voucher date",
                PlaceHolder: "",
                IsMandatory: true,
                BindValue: "txt_voucher_date",
                Json_Attribute: "voucher_date",
                componentType: ComponentType.DATE_FIELD,
                showInSummary: true,
                IsReadOnly: true,
                IsVerticalView: true,
                DefaultToday: true,
                validation: [
                  {
                    rule: ValidationRule.REQUIRED,
                    message: "Voucher date is required",
                  },
                ],
              },
              {
                IncludeLabel: true,
                Label: "Party / account name",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "drp_party_ledger",
                Json_Attribute: "party_ledger_id",
                componentType: ComponentType.SEARCHABLE_DROPDOWN,
                LookupName: "journal_ledgers",
                showInSummary: true,
                IsReadOnly: true,
                IsVerticalView: true,
              },
              {
                IncludeLabel: true,
                Label: "Ref No.",
                PlaceHolder: "Ref No.",
                IsMandatory: false,
                BindValue: "txt_Ref_no",
                Json_Attribute: "ref_no",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: true,
                IsReadOnly: true,
                IsVerticalView: true,
                inputType: InputType.TEXT,
              },
              {
                IncludeLabel: true,
                Label: "Voucher type",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_voucher_type_",
                Json_Attribute: "voucher_type",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: true,
                Default_Value: "BankReconciliation",
                IsReadOnly: true,
                IsVerticalView: true,
                inputType: InputType.TEXT,
              },
              {
                IncludeLabel: true,
                Label: "Transaction amount",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_pdc_transaction_amount",
                Json_Attribute: "pdc_transaction_amount",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: true,
                IsReadOnly: true,
                IsVerticalView: true,
                inputType: InputType.TEXT,
              },
              {
                IncludeLabel: true,
                Label: "Transaction type",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_pdc_transaction_type",
                Json_Attribute: "pdc_transaction_type",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: true,
                IsReadOnly: true,
                IsVerticalView: true,
                inputType: InputType.TEXT,
              },
              {
                IncludeLabel: true,
                Label: "Reference date",
                PlaceHolder: "",
                IsMandatory: true,
                BindValue: "txt_reference_date",
                Json_Attribute: "ref_date",
                componentType: ComponentType.DATE_FIELD,
                showInSummary: true,
                IsReadOnly: true,
                IsVerticalView: true,
                validation: [
                  {
                    rule: ValidationRule.REQUIRED,
                    message: "Reference date is required",
                  },
                ],
              },
              {
                IncludeLabel: true,
                Label: "Banks",
                PlaceHolder: "Search bank...",
                IsMandatory: true,
                BindValue: "drp_bank",
                Json_Attribute: "bank_ledger_id",
                componentType: ComponentType.SEARCHABLE_DROPDOWN,
                LookupName: "bank_ledgers",
                showInSummary: true,
                IsVerticalView: true,
                validation: [
                  {
                    rule: ValidationRule.REQUIRED,
                    message: "Bank is required",
                  },
                ],
              },
              {
                IncludeLabel: true,
                Label: "Source narration",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_source_narration",
                Json_Attribute: "narration",
                componentType: ComponentType.TEXT_AREA,
                showInSummary: true,
                IsReadOnly: true,
                IsVerticalView: true,
              },
              {
                IncludeLabel: true,
                Label: "Details",
                PlaceHolder: "Enter reconciliation details",
                IsMandatory: true,
                BindValue: "txt_reconciliation_narration",
                Json_Attribute: "reconciliation_narration",
                componentType: ComponentType.TEXT_AREA,
                showInSummary: true,
                IsVerticalView: true,
                validation: [
                  {
                    rule: ValidationRule.REQUIRED,
                    message: "Details is required",
                  },
                ],
              },
              {
                IncludeLabel: true,
                Label: "Cheque No.",
                PlaceHolder: "Enter cheque number",
                IsMandatory: true,
                BindValue: "txt_cheque_no",
                Json_Attribute: "cheque_no",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: true,
                IsVerticalView: true,
                inputType: InputType.TEXT,
                validation: [
                  {
                    rule: ValidationRule.REQUIRED,
                    message: "Cheque No. is required",
                  },
                ],
              },
              {
                IncludeLabel: true,
                Label: "Cheque date",
                PlaceHolder: "",
                IsMandatory: true,
                BindValue: "txt_cheque_date",
                Json_Attribute: "cheque_date",
                componentType: ComponentType.DATE_FIELD,
                showInSummary: true,
                IsVerticalView: true,
                validation: [
                  {
                    rule: ValidationRule.REQUIRED,
                    message: "Cheque date is required",
                  },
                ],
              },
              {
                IncludeLabel: false,
                Label: "PDC reminder source",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "pdc_reminder_source_id",
                Json_Attribute: "pdc_reminder_source_id",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsReadOnly: true,
                IsVerticalView: true,
                inputType: InputType.TEXT,
                style: { display: "none" },
              },
            ],
          },
         
        ],
      } as any,
      {
        componentType: ComponentType.BUTTON,
        name: "Submit",
        Label: "Submit",
        BindValue: "btn_submit",
        onPressAction: "save",
        style: {
          backgroundColor: "#22c55e",
          textColor: "#FFFFFF",
          padding: 12,
          borderRadius: 8,
          marginTop: 10,
        },
      },
    ],
  },
];

